export const MOTIVATION_RANK_MULTIPLIERS = {
  1: 1.24,
  2: 1.12,
  3: 1.0,
};

export const MOTIVATION_VALUE_ALIASES = {
  better_quality_of_life: "slower_pace_less_stress",
  closer_to_family_or_home_base: "closer_to_family",
};

export const MOTIVATION_OPTIONS = [
  { id: "safety", label: "To feel safer", primary_dimension: "infrastructure_healthcare", secondary_dimension: "lifestyle_fit", weight_multiplier: MOTIVATION_RANK_MULTIPLIERS },
  { id: "political_climate", label: "To live in a more stable political environment", primary_dimension: "infrastructure_healthcare", secondary_dimension: "residency_path_feasibility", weight_multiplier: MOTIVATION_RANK_MULTIPLIERS },
  { id: "lower_cost_of_living", label: "To lower my cost of living", primary_dimension: "financial_sustainability", weight_multiplier: MOTIVATION_RANK_MULTIPLIERS },
  { id: "better_healthcare", label: "To access better healthcare", primary_dimension: "infrastructure_healthcare", weight_multiplier: MOTIVATION_RANK_MULTIPLIERS },
  { id: "slower_pace_less_stress", label: "To enjoy a slower pace of life", primary_dimension: "lifestyle_fit", weight_multiplier: MOTIVATION_RANK_MULTIPLIERS },
  { id: "work_or_business_opportunities", label: "To pursue work or business opportunities", primary_dimension: "financial_sustainability", secondary_dimension: "residency_path_feasibility", weight_multiplier: MOTIVATION_RANK_MULTIPLIERS },
  { id: "retirement_planning", label: "To plan for retirement", primary_dimension: "financial_sustainability", secondary_dimension: "lifestyle_fit", weight_multiplier: MOTIVATION_RANK_MULTIPLIERS },
  { id: "education_or_family_reasons", label: "To support education or family needs", primary_dimension: "infrastructure_healthcare", secondary_dimension: "lifestyle_fit", weight_multiplier: MOTIVATION_RANK_MULTIPLIERS },
  { id: "adventure_or_new_experience", label: "To experience something new", primary_dimension: "lifestyle_fit", weight_multiplier: MOTIVATION_RANK_MULTIPLIERS },
  { id: "closer_to_family", label: "To be closer to family", primary_dimension: "lifestyle_fit", secondary_dimension: "residency_path_feasibility", weight_multiplier: MOTIVATION_RANK_MULTIPLIERS },
];

const motivationOptionMap = new Map(MOTIVATION_OPTIONS.map((option) => [option.id, option]));

export const normalizeMotivations = (values = []) => {
  const normalized = [];

  values.forEach((value) => {
    const normalizedValue = MOTIVATION_VALUE_ALIASES[value] || value;
    if (!motivationOptionMap.has(normalizedValue) || normalized.includes(normalizedValue)) return;
    normalized.push(normalizedValue);
  });

  return normalized.slice(0, 3);
};

export const getMotivationOption = (value) => motivationOptionMap.get(MOTIVATION_VALUE_ALIASES[value] || value) || null;

export const getMotivationLabel = (value) => getMotivationOption(value)?.label || value;